export const GRANDFATHERED_REFERRAL_DETAILS_BANNER =
    'This referral is grandfathered based on plan benefits. FMH program management will begin after the grandfathering period ends.';

export const hasGrandfatheredReferralsInFilterOptions = (
    filterOptions?: Record<string, string[]>,
): boolean => filterOptions?.grandfathered?.includes('true') ?? false;

export const isGrandfatheredReferral = (
    referral?: { grandfathered?: boolean },
    showGrandfatheredPharmacy = false,
): boolean => showGrandfatheredPharmacy && !!referral?.grandfathered;
